import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Field, reduxForm, FieldArray,
} from 'redux-form';
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  Container,
  Badge,
} from 'reactstrap';
import EyeIcon from 'mdi-react/EyeIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import moment from 'moment';
import renderSelectField from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import renderRadioField from '../../../shared/components/form/RadioButton';
import TextBox from '../../../shared/components/form/TextBox';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import validate from './validate';
import { dateFormat } from '../../../helpers/dateFormat';
import { getCurrentUser } from '../../../helpers/storage';
import {
  MaxSizeFile, AcceptTypeFile,
} from '../../../constants/enums';
import {
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

const TrueFalseValues = [
  { value: true, label: 'Si' },
  { value: false, label: 'No' },
];

class EditUser extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmitFoto: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    resetPasswordHandler: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    esAdmin: PropTypes.bool,
    esProfesor: PropTypes.bool,
    esFuncionario: PropTypes.bool,
    esAlumno: PropTypes.bool,
    provenienteDePuebloOriginario: PropTypes.bool,
    saludPoseeDiscapacidadVisual: PropTypes.bool,
    saludPoseeDiscapacidadAuditiva: PropTypes.bool,
    saludPoseeDiscapacidadMotora: PropTypes.bool,
    saludPoseeDiscapacidadCognitiva: PropTypes.bool,
    saludPoseeOtraDiscapacidad: PropTypes.bool,
    id: PropTypes.number,
    genero: PropTypes.number,
    age: PropTypes.number,
    estadoCivil: PropTypes.number,
    arancelCero: PropTypes.bool,
    grupoSanguineo: PropTypes.string,
    categoriasProfesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    paises: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    escalafon: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    materias: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    gruposSanguineos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    estadosCiviles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    generos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    showProfile: PropTypes.bool,
    loadingFile: PropTypes.bool,
    nombre: PropTypes.string,
    apellido: PropTypes.string,
    numeroDocumento: PropTypes.string,
    fechaNacimiento: PropTypes.string,
    lugarNacimiento: PropTypes.string,
    fechaFinArancelCero: PropTypes.string,
    namePhoto: PropTypes.string,
    urlPhoto: PropTypes.string,

    onAddItemArray: PropTypes.func.isRequired,
    onDeleteItemArray: PropTypes.func.isRequired,
    onChangeText: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,
    onRadioChanges: PropTypes.func.isRequired,
  }

  static defaultProps = {
    submitting: false,
    esAdmin: false,
    esProfesor: false,
    esFuncionario: false,
    esAlumno: false,
    provenienteDePuebloOriginario: false,
    saludPoseeDiscapacidadVisual: false,
    saludPoseeDiscapacidadAuditiva: false,
    saludPoseeDiscapacidadMotora: false,
    saludPoseeDiscapacidadCognitiva: false,
    saludPoseeOtraDiscapacidad: false,
    id: 0,
    genero: 0,
    age: 0,
    estadoCivil: 0,
    arancelCero: false,
    grupoSanguineo: '',
    showProfile: false,
    loadingFile: false,
    nombre: '',
    apellido: '',
    numeroDocumento: '',
    fechaNacimiento: '',
    lugarNacimiento: '',
    fechaFinArancelCero: '',
    namePhoto: '',
    urlPhoto: '',
  }

  constructor(props) {
    super(props);
    const {
      provenienteDePuebloOriginario,
      saludPoseeOtraDiscapacidad,
      esProfesor,
    } = props;

    this.state = {
      provenienteDePuebloOriginario,
      saludPoseeOtraDiscapacidad,
      showOtherData: false,
      showCategoriaProfesor: esProfesor,
      showPhoto: true,
    };
  }

  showHideOtherData = () => {
    const { showOtherData } = this.state;
    this.setState({ showOtherData: !showOtherData });
  }

  showHideCategoriaProfesor = ({ target }) => {
    this.setState({ showCategoriaProfesor: target.checked });
  }

  onShowPhoto = () => {
    this.setState(prevState => ({
      showPhoto: !prevState.showPhoto,
    }));
  }

  categoriaProfesorTable = ({
    fields = {},
    categoriasProfesores,
    meta: { error, submitFailed },
    onAddItemArray,
    onDeleteItemArray,
    onChangeText,
    onChangeSelect,
    materias,
    escalafon,
  }) => (
    <>
      <table className="table table-striped check-in">
        <thead>
          <tr style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
            <th colSpan={8}>
              <div className="invoice-detail">
                <Row>
                  <Col md={3} lg={3}>
                    <h4>Categor&iacute;a docente</h4>
                  </Col>
                  <Col md={3} lg={3}>
                    {fields.length <= 20
                      ? (
                        <Button
                          size="sm"
                          color="primary"
                          style={{ marginBottom: '0px' }}
                          onClick={onAddItemArray}
                          className="font-weight-bold"
                        >
                          <i className="fa fa-plus" />
                          {' '}
                          Agregar
                        </Button>
                      )
                      : null
                    }
                  </Col>
                </Row>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="col col-1">#</th>
            <th scope="col col-1">Materia</th>
            <th scope="col col-1">Escalaf&oacute;n</th>
            <th scope="col col-1">Notas</th>
            <th scope="col col-1">{' '}</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((categoriaProfesor, index) => (
            <tr
              key={`${categoriaProfesor}`}
              id={`${categoriaProfesor}`}
              className={categoriasProfesores[index].removed ? 'hidden' : ''}
            >
              <th className="col col-1 text-left">
                <div className="form">
                  <h4>{index + 1}</h4>
                  <input type="hidden" name={`${categoriaProfesor}.id`} />
                </div>
              </th>
              <th className="col col-3 text-left">
                <div className="form">
                  <div className="form__form-group" style={{ marginBottom: 0 }}>
                    <div className="form__form-group-field">
                      <Field
                        name={`${categoriaProfesor}.materia`}
                        component={renderSelectField}
                        placeholder="Materia"
                        options={materias}
                        onChange={props => onChangeSelect({ option: props, name: 'materia', index })}
                      />
                      <span className="form__form-group-label required">{' '}</span>
                    </div>
                  </div>
                </div>
              </th>

              <th className="col col-2 text-left">
                <div className="form">
                  <div className="form__form-group" style={{ marginBottom: 0 }}>
                    <div className="form__form-group-field">
                      <Field
                        name={`${categoriaProfesor}.escalafon`}
                        component={renderSelectField}
                        placeholder="Escalaf&oacute;n"
                        options={escalafon}
                        onChange={props => onChangeSelect({ option: props, name: 'escalafon', index })}
                      />
                      <span className="form__form-group-label required">{' '}</span>
                    </div>
                  </div>
                </div>
              </th>

              <th className="col col-3">
                <div className="form">
                  <div className="form__form-group" style={{ marginBottom: 0 }}>
                    <div className="form__form-group-field">
                      <Field
                        name={`${categoriaProfesor}.notas`}
                        component={TextBox}
                        type="text"
                        maxLength="256"
                        placeholder="Notas"
                        onChange={v => onChangeText(v, index)}
                      />
                      <span className="form__form-group-label required">{' '}</span>
                    </div>
                  </div>
                </div>
              </th>

              <th className="col col-1">
                <Button
                  onClick={() => onDeleteItemArray(index)}
                  size="sm"
                  outline
                  color="danger"
                  style={{ marginBottom: '0px' }}
                  className="font-weight-bold"
                >
                  <i className="fa fa-trash" aria-hidden="true" />
                </Button>
              </th>
            </tr>
          ))}
        </tbody>
      </table>
      {
        submitFailed && error && (
          <div className="form__form-group-input-wrap form__form-group-input-wrap--error">
            <span className="form__form-group-error" style={{ marginBottom: '0.5rem', fontSize: '16px' }}>
              *
              {error}
            </span>
          </div>
        )
      }
    </>
  );

  onFileChange = (e) => {
    const file = e.target.files[0];
    if (!file || file.size <= 0) {
      createWarningMessage('Debe elegir una imagen');
      e.target.value = null;
      return;
    }

    if (file.size > MaxSizeFile) {
      const maxSizeFileMb = MaxSizeFile / 1000000;
      createWarningMessage(`El tamaño máximo es ${maxSizeFileMb} MB`);

      e.target.value = null;
      return;
    }

    if (!AcceptTypeFile.includes(file.type)) {
      createWarningMessage('El tipo de imagen no es válido');

      e.target.value = null;
      return;
    }

    const { onSubmitFoto } = this.props;
    onSubmitFoto(e.target.files);
  }

  render() {
    const {
      provenienteDePuebloOriginario,
      saludPoseeOtraDiscapacidad,
      showOtherData,
      showCategoriaProfesor,
      showPhoto,
    } = this.state;

    const {
      esAdmin,
      esProfesor,
      esFuncionario,
      esAlumno,
      submitting,
      handleSubmit,
      resetPasswordHandler,
      onBack,
      genero,
      grupoSanguineo,
      estadoCivil,
      arancelCero,
      saludPoseeDiscapacidadVisual,
      saludPoseeDiscapacidadAuditiva,
      saludPoseeDiscapacidadMotora,
      saludPoseeDiscapacidadCognitiva,
      onFilterChanges,
      age,
      paises,
      escalafon,
      materias,

      onAddItemArray,
      onDeleteItemArray,
      onChangeText,
      onChangeSelect,
      onRadioChanges,

      gruposSanguineos,
      estadosCiviles,
      generos,
      showProfile,
      nombre,
      apellido,
      numeroDocumento,
      fechaNacimiento,
      id,
      categoriasProfesores = [],
      lugarNacimiento,
      fechaFinArancelCero,
      urlPhoto,
      namePhoto,
      loadingFile,
    } = this.props;

    const otherDataBtnClass = showOtherData ? 'fa fa-angle-down collapse-btn' : 'fa fa-angle-right collapse-btn';

    const otherDataClass = showProfile || showOtherData ? '' : 'hidden';
    const categoriaProfesorDataClass = showCategoriaProfesor ? '' : 'hidden';

    const currentUser = getCurrentUser();

    const editMainInfo = currentUser.esAdmin || currentUser.esFuncionario;
    const birdDate = fechaNacimiento ? moment(fechaNacimiento).format('DD/MM/YYYY') : '';

    const requiredNameClass = `form__form-group-label ${!showProfile ? 'required' : ''}`;
    const requiredPhoneClass = `form__form-group-label ${showProfile ? 'required' : ''}`;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <input name="editProfile" value={`${showProfile}`} type="hidden" />
              <Col md={12} lg={12}>
                <div className="card__title">
                  <h5 className="bold-text">Informaci&oacute;n personal</h5>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="form__form-group">
                  <span className={requiredNameClass}>Nombre</span>
                  <div className="form__form-group-field">
                    {editMainInfo
                      ? (
                        <Field
                          name="nombre"
                          component={TextBox}
                          type="text"
                          placeholder="Nombre"
                          autoComplete="false"
                          maxLength="50"
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          value={nombre}
                          type="text"
                          placeholder="Nombre"
                          disabled="disabled"
                        />
                      )
                    }
                  </div>
                </div>

                <div className="form__form-group">
                  <span className={requiredNameClass}>Apellido</span>
                  <div className="form__form-group-field">
                    {editMainInfo
                      ? (
                        <Field
                          name="apellido"
                          component={TextBox}
                          type="text"
                          placeholder="Apellido"
                          maxLength={50}
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          value={apellido}
                          type="text"
                          placeholder="Apellido"
                          disabled="disabled"
                        />
                      )
                    }
                  </div>
                </div>

                <div className="form__form-group">
                  <span className={requiredNameClass}>N&uacute;mero de documento</span>
                  <div className="form__form-group-field">
                    {editMainInfo
                      ? (
                        <Field
                          name="numeroDocumento"
                          component={TextBox}
                          type="number"
                          placeholder="N&uacute;mero de documento"
                          maxLength={10}
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          value={numeroDocumento}
                          type="text"
                          placeholder="N&uacute;mero de documento"
                          disabled="disabled"
                        />
                      )
                    }
                  </div>
                </div>

                <div className="form__form-group">
                  <span className={requiredNameClass}>Fecha de nacimiento</span>
                  {editMainInfo
                    ? (
                      <div className="form__form-group-field">
                        <Field
                          name="fechaNacimiento"
                          component={TextBox}
                          type="date"
                          placeholder="Fecha de nacimiento"
                          autoComplete="false"
                          format={value => value && value.split('T')[0]}
                          onChange={v => onChangeText(v)}
                        />
                      </div>
                    )
                    : (
                      <div className="form__form-group-field">
                        <input
                          value={birdDate}
                          type="text"
                          placeholder="Fecha de nacimiento"
                          disabled="disabled"
                        />
                      </div>
                    )
                  }
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Lugar de nacimiento</span>
                  <div className="form__form-group-field">
                    {editMainInfo
                      ? (
                        <Field
                          name="lugarNacimiento"
                          component={TextBox}
                          type="text"
                          placeholder="Lugar de nacimiento"
                          maxLength={50}
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          value={lugarNacimiento}
                          type="text"
                          placeholder="Lugar de nacimiento"
                          disabled="disabled"
                        />
                      )
                    }

                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Nacionalidad</span>
                  <div className="form__form-group-field">
                    <Field
                      name="nacionalidad"
                      component={renderSelectField}
                      placeholder="Nacionalidad"
                      autoComplete="false"
                      options={paises}
                      onChange={v => onFilterChanges('nacionalidad', 'nacionalidadPaisId', v)}
                      isDisabled={!editMainInfo}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Proveniente de Pueblos originarios</span>
                </div>

                <div className="form__form-group">
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`pueblo_${g.value}`}
                        name="provenienteDePuebloOriginario"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={provenienteDePuebloOriginario === g.value}
                        onChange={v => onRadioChanges('provenienteDePuebloOriginario', v)}
                        disabled={!editMainInfo}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Nombre de pueblo originario</span>
                  <div className="form__form-group-field">
                    {provenienteDePuebloOriginario
                      ? (
                        <Field
                          name="puebloOriginario"
                          component={TextBox}
                          type="text"
                          placeholder="Nombre de pueblo originario"
                          maxLength={50}
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          type="text"
                          placeholder="Especificar pueblo originario"
                          disabled="disabled"
                        />
                      )
                    }
                  </div>
                </div>
              </Col>
              {/* /////////////////////////////////////////////////////////////////    START SECTION CONTACT-ADDRESS */}
              <Col md={12} lg={6}>

                <div className="form__form-group">
                  <span className="form__form-group-label">G&eacute;nero</span>
                  <div className="form__form-group-field">
                    {generos.map(g => (
                      <Field
                        key={`genero_${g.value}`}
                        name="genero"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={genero === g.value}
                        disabled={!editMainInfo}
                        onChange={v => onRadioChanges('genero', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Edad</span>
                  <div className="form__form-group-field">
                    <input
                      name="age"
                      type="text"
                      value={age > 0 ? age : ''}
                      placeholder="Edad (autom&aacute;tico)"
                      disabled="disabled"
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Grupo sangu&iacute;neo</span>
                  <div className="form__form-group-field">
                    {gruposSanguineos.map(g => (
                      <Field
                        key={`grupo_sanguineo_${g.value}`}
                        name="grupoSanguineo"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={grupoSanguineo === g.value}
                        disabled={!editMainInfo}
                        onChange={v => onRadioChanges('grupoSanguineo', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Email</span>
                  <div className="form__form-group-field">
                    <Field
                      name="email"
                      component={TextBox}
                      type="text"
                      placeholder="Email"
                      disabled={!editMainInfo}
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Estado Civil</span>
                  <div className="form__form-group-field">
                    {estadosCiviles.map(g => (
                      <Field
                        key={`estado_civil_${g.value}`}
                        name="estadoCivil"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={estadoCivil === g.value}
                        disabled={!editMainInfo}
                        onChange={v => onRadioChanges('estadoCivil', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label required">Arancel Cero</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`arancel_cero_${g.value}`}
                        name="arancelCero"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={arancelCero === g.value}
                        onChange={v => onRadioChanges('arancelCero', v)}
                        disabled={!editMainInfo}
                      />
                    ))}
                  </div>
                  {
                    arancelCero ? (
                      <>
                        <span className={requiredNameClass}>Fecha fin Arancel Cero</span>
                        <div className="form__form-group-field">
                          {
                            editMainInfo
                              ? (
                                <Field
                                  name="fechaFinArancelCero"
                                  component={TextBox}
                                  type="date"
                                  placeholder="Fecha fin Arancel Cero"
                                  autoComplete="false"
                                  readOnly={!editMainInfo}
                                  onChange={v => onChangeText(v)}
                                  format={value => value && value.split('T')[0]}
                                />
                              )
                              : <input name="fecha" type="text" value={dateFormat(fechaFinArancelCero)} disabled />
                          }
                        </div>
                      </>
                    ) : null
                  }
                </div>

              </Col>
              <Col md={12} lg={12}>
                <div className="card__title subtitle">
                  <h5 className="bold-text">Domicilio particular</h5>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Calle</span>
                  <div className="form__form-group-field">
                    <Field
                      name="domicilioCalle"
                      component={TextBox}
                      type="text"
                      placeholder="Calle"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">N&uacute;mero</span>
                  <div className="form__form-group-field">
                    <Field
                      name="domicilioNumero"
                      component={TextBox}
                      type="text"
                      placeholder="N&uacute;mero"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Localidad</span>
                  <div className="form__form-group-field">
                    <Field
                      name="domicilioLocalidad"
                      component={TextBox}
                      type="text"
                      placeholder="Localidad"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="form__form-group">
                  <span className="form__form-group-label required">Tel&eacute;fono Celular</span>
                  <div className="form__form-group-field">
                    <Field
                      name="domicilioTelefono"
                      component={TextBox}
                      type="text"
                      placeholder="Tel&eacute;fono"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Pais</span>
                  <div className="form__form-group-field">
                    <Field
                      name="domicilioPais"
                      component={renderSelectField}
                      placeholder="Pais"
                      autoComplete="false"
                      options={paises}
                      onChange={v => onFilterChanges('domicilioPais', 'domicilioPaisId', v)}
                    />
                  </div>
                </div>
              </Col>
              {/* /////////////////////////////////////////////////////////////////    END SECTION CONTACT-ADDRESS */}
              {/* /////////////////////////////////////////////////////////////////    START SECTION WORK EMPLOYMENT */}
              <Col md={12} lg={12} className={showProfile ? 'hidden' : ''}>
                <i
                  onKeyDown={this.showHideOtherData}
                  onClick={this.showHideOtherData}
                  className={otherDataBtnClass}
                  role="button"
                  tabIndex="0"
                > {showOtherData ? 'Ocultar' : 'Mostrar'} datos adicionales...
                </i>
              </Col>
              <Col md={12} lg={12} className={otherDataClass}>
                <div className="card__title subtitle">
                  <h5 className="bold-text">Domicilio Laboral</h5>
                </div>
                <div className="form__form-group required">
                  <span className="form__form-group-label">Nombre de la empresa</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoEmpresa"
                      component={TextBox}
                      type="text"
                      placeholder="Nombre de la empresa"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} lg={6} className={otherDataClass}>
                <div className="form__form-group">
                  <span className="form__form-group-label">Calle</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoCalle"
                      component={TextBox}
                      type="text"
                      placeholder="Calle"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">N&uacute;mero</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoNumero"
                      component={TextBox}
                      type="text"
                      placeholder="N&uacute;mero"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Localidad</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoLocalidad"
                      component={TextBox}
                      type="text"
                      placeholder="Localidad"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} lg={6} className={otherDataClass}>
                <div className="form__form-group required">
                  <span className="form__form-group-label">Tel&eacute;fono</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoTelefono"
                      component={TextBox}
                      type="text"
                      placeholder="Tel&eacute;fono"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Pais</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoPais"
                      component={renderSelectField}
                      placeholder="Pais"
                      autoComplete="false"
                      options={paises}
                      onChange={v => onFilterChanges('trabajoPais', 'trabajoPaisId', v)}
                    />
                  </div>
                </div>
                <div className="form__form-group required">
                  <span className="form__form-group-label">Horario laboral</span>
                  <div className="form__form-group-field">
                    <Field
                      name="trabajoHorario"
                      component={TextBox}
                      type="text"
                      placeholder="Horario laboral"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
              </Col>
              {/* /////////////////////////////////////////////////////////////////     END SECTION EMPLOYMENT */}
              {/* /////////////////////////////////////////////////////////////////    OTHER DATA */}
              <Col md={12} lg={12} className={otherDataClass}>
                <div className="card__title subtitle">
                  <h5 className="bold-text">Otros Datos Personales</h5>
                </div>
              </Col>
              <Col md={12} lg={6} className={otherDataClass}>
                <div className="form__form-group required">
                  <span className="form__form-group-label">Padece alguna enfermedad? (Especificar)</span>
                  <div className="form__form-group-field">
                    <Field
                      name="saludEnfermedad"
                      component={TextBox}
                      type="text"
                      placeholder="Padece alguna enfermedad? Especificar:"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Toma alg&uacute;n medicamento? (Especificar)</span>
                  <div className="form__form-group-field">
                    <Field
                      name="saludMedicamente"
                      component={TextBox}
                      type="text"
                      placeholder="Toma alg&uacute;n medicamento? (Especificar):"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Al&eacute;rgico a</span>
                  <div className="form__form-group-field">
                    <Field
                      name="saludAlergia"
                      component={TextBox}
                      type="text"
                      placeholder="Al&eacute;rgico a"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className={requiredPhoneClass}>
                    Tel&eacute;fono de contacto en caso de emergencia
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="emergenciaNumero"
                      component={TextBox}
                      type="text"
                      placeholder="Tel&eacute;fono de contacto en caso de emergencia"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className={requiredPhoneClass}>Nombre de contacto de emergencia</span>
                  <div className="form__form-group-field">
                    <Field
                      name="emergenciaContacto"
                      component={TextBox}
                      type="text"
                      placeholder="Nombre de contacto de emergencia"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
                <div className="form__form-group required">
                  <span className="form__form-group-label">Relaci&oacute;n parentesca de contacto</span>
                  <div className="form__form-group-field">
                    <Field
                      name="emergenciaRelacionParentesca"
                      component={TextBox}
                      type="text"
                      placeholder="Relaci&oacute;n parentesca de contacto"
                      onChange={v => onChangeText(v)}
                    />
                  </div>
                </div>
              </Col>

              <Col md={12} lg={6} className={otherDataClass}>

                <div className="form__form-group">
                  <span className="form__form-group-label">Padece discapacidad visual</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`saludPoseeDiscapacidadVisual_${g.value}`}
                        name="saludPoseeDiscapacidadVisual"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={saludPoseeDiscapacidadVisual === g.value}
                        onChange={v => onRadioChanges('saludPoseeDiscapacidadVisual', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Padece discapacidad auditiva</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`saludPoseeDiscapacidadAuditiva_${g.value}`}
                        name="saludPoseeDiscapacidadAuditiva"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={saludPoseeDiscapacidadAuditiva === g.value}
                        onChange={v => onRadioChanges('saludPoseeDiscapacidadAuditiva', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Padece discapacidad motora</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`saludPoseeDiscapacidadMotora_${g.value}`}
                        name="saludPoseeDiscapacidadMotora"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={saludPoseeDiscapacidadMotora === g.value}
                        onChange={v => onRadioChanges('saludPoseeDiscapacidadMotora', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Padece discapacidad cognitiva</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`saludPoseeDiscapacidadCognitiva_${g.value}`}
                        name="saludPoseeDiscapacidadCognitiva"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={saludPoseeDiscapacidadCognitiva === g.value}
                        onChange={v => onRadioChanges('saludPoseeDiscapacidadCognitiva', v)}
                      />
                    ))}
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">Padece otra discapacidad</span>
                  <div className="form__form-group-field">
                    {TrueFalseValues.map(g => (
                      <Field
                        key={`saludPoseeOtraDiscapacidad_${g.value}`}
                        name="saludPoseeOtraDiscapacidad"
                        component={renderRadioField}
                        label={g.label}
                        radioValue={g.value}
                        defaultChecked={saludPoseeOtraDiscapacidad === g.value}
                        onChange={v => onRadioChanges('saludPoseeOtraDiscapacidad', v)}
                      />
                    ))}
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Especificar otra discapacidad</span>
                  <div className="form__form-group-field">
                    {saludPoseeOtraDiscapacidad
                      ? (
                        <Field
                          name="saludOtraDiscapacidad"
                          component={TextBox}
                          type="text"
                          placeholder="Especificar otra discapacidad"
                          maxLength={50}
                          onChange={v => onChangeText(v)}
                        />
                      )
                      : (
                        <input
                          type="text"
                          placeholder="Especificar otra discapacidad"
                          disabled="disabled"
                        />
                      )
                    }
                  </div>
                </div>
              </Col>
              {/* /////////////////////////////////////////////////////////////////     END OTHER DATA */}

              <Col sm={12} md={8} lg={6}>
                <Container className="summary-container">
                  <Row dir="ltr">
                    {[urlPhoto].map(url => (
                      <Col
                        className="pb-4"
                        md={12}
                        key={`subject_${url}`}
                      >
                        <Card
                          outline
                          color="primary"
                          className="link-card pb-0"
                        >
                          <CardBody className="summary-card summary-card--primary">
                            <div className="summary-card__body checklist-card">
                              <h4
                                className="summary-card__title"
                                style={{
                                  display: 'flex',
                                  gap: '1rem',
                                  marginBottom: '0',
                                  flexWrap: 'wrap',
                                }}
                              >
                                <Badge
                                  color="primary"
                                  pill
                                  onClick={this.onShowPhoto}
                                >
                                  {
                                    showPhoto ? <EyeIcon /> : <EyeOffIcon />
                                  }
                                </Badge>
                                {
                                  loadingFile
                                    ? <LoadingSpinner />
                                    : null
                                }
                                {
                                  !loadingFile && showPhoto
                                    ? (
                                      <div className="file-input">
                                        <Input
                                          type="file"
                                          className="file hide"
                                          id="photoName"
                                          name="photoName"
                                          placeholder="Foto"
                                          accept={AcceptTypeFile}
                                          onChange={this.onFileChange}
                                        />
                                        <Label
                                          for="photoName"
                                          className="btn btn-sm btn-primary"
                                          style={{ marginLeft: 0, marginBottom: 0 }}
                                        >
                                          Cambiar Foto
                                        </Label>
                                        <p className="file-name">{namePhoto}</p>
                                      </div>
                                    ) : null
                                }
                              </h4>
                              {loadingFile ? <LoadingSpinner /> : null}
                              {
                                !loadingFile && showPhoto
                                  ? (
                                    <>
                                      <div className="summary-card__item">
                                        <img
                                          alt="Foto del alumno"
                                          src={urlPhoto || ''}
                                        />
                                      </div>
                                    </>
                                  ) : null
                              }
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </Col>
              <Col md={12} lg={12} className={editMainInfo && !showProfile ? '' : 'hidden'}>
                <div className="card__title subtitle">
                  <h5 className="bold-text">Rol de usuario</h5>
                </div>
                <div className="form--horizontal">
                  <div className="form__form-group">
                    <div className="form__form-group-field">
                      <Field
                        name="esAlumno"
                        component={renderCheckBoxField}
                        label="Es alumno?"
                        value={esAlumno ? 'checked' : ''}
                        defaultChecked={esAlumno}
                      />
                      <Field
                        name="esProfesor"
                        component={renderCheckBoxField}
                        label="Es profesor?"
                        value={esProfesor ? 'checked' : ''}
                        defaultChecked={esProfesor}
                        onChange={this.showHideCategoriaProfesor}
                      />
                      <Field
                        name="esFuncionario"
                        component={renderCheckBoxField}
                        label="Es funcionario?"
                        value={esFuncionario ? 'checked' : ''}
                        defaultChecked={esFuncionario}
                      />
                      <Field
                        name="esAdmin"
                        component={renderCheckBoxField}
                        label="Es administrador?"
                        checked={esAdmin ? 'checked' : ''}
                        defaultChecked={esAdmin}
                      />
                    </div>
                  </div>


                </div>
              </Col>
            </Form>

            <div className={`table-wrapper ${categoriaProfesorDataClass}`} style={{ marginBottom: '20px' }}>
              <FieldArray
                name="categoriasProfesores"
                component={this.categoriaProfesorTable}
                categoriasProfesores={categoriasProfesores}
                escalafon={escalafon}
                materias={materias}
                onAddItemArray={onAddItemArray}
                onDeleteItemArray={onDeleteItemArray}
                onChangeText={onChangeText}
                onChangeSelect={onChangeSelect}
              />
            </div>

            {id > 0 && editMainInfo && (
              <div>
                <button
                  type="submit"
                  className="btn btn-link"
                  disabled={submitting}
                  onClick={resetPasswordHandler}
                >Restablecer contrase&ntilde;a
                </button>
              </div>
            )}
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const EditUserForm = reduxForm({
  form: 'EditUserForm',
  validate,
  enableReinitialize: true,
})(EditUser);

export default setPropsAsInitialValues(EditUserForm);
